// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__hgl7X","rootCenter":"LoadMoreObserver_rootCenter__2JSER","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__141xi"};